<div *ngIf="formToPopulate" class="dsforms-shortcode-layout-container">
    <dsf-dsforms-content-layout
        [formToPopulate]="formToPopulate"
        [formNotFound]="formNotFound"
        [isSaving]="isSaving"
        (save)="onSave($event)"
        [displayChoice]="displayChoice"
        [messageToDisplay]="messageToDisplay"
    ></dsf-dsforms-content-layout>
</div>
